import axios, { AxiosRequestConfig } from 'axios';
import CommonUtils from '../utils/CommonUtils'
import { GlobalConsts } from '../config';


//默认 Content-Type: application/json，如果需要处理，可以在这里进行配置
//axios.defaults.headers
console.log("------------------------------", import.meta.env.AXIOS_BASE_URL)
// 创建实例
const axiosInstance = axios.create({
  //同意前缀，方便生产环境nginx转发到
  //baseURL:import.meta.env.AXIOS_BASE_URL as string,
  //send cookies when cross-domain requests
  baseURL: import.meta.env.DEV ? GlobalConsts.DevBaseUrl : GlobalConsts.ProdBaseUrl,
  withCredentials: true,
  timeout: 150000,
});

// request interceptor
axiosInstance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    // 可以进行请求拦截处理，如添加请求头，token 等
    //config.headers?[GlobalConsts.TokenKey] = CommonUtils.getLocalStore(GlobalConsts.TokenKey)
    if(CommonUtils.getLocalStore(GlobalConsts.TokenKey)) {
      //headers是Record类型，不建议直接 config.headers?[GlobalConsts.TokenKey] 赋值
      config.headers = {
        [GlobalConsts.TokenKeyToBackend]: CommonUtils.getLocalStore(GlobalConsts.TokenKey)!,
        [GlobalConsts.UsernameKeyToBackend]: CommonUtils.getLocalStore(GlobalConsts.CurrentLoginUserName)!
      }
    }
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);
// response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    const res = response.data;
    console.log("====================",res)
    //token过期
    if (res.code == 302 || res.code == 10003) {
      //认证异常，需要重新登录
      CommonUtils.clearLocalStore();
      if(window.location.pathname !== "/login"){
        window.location.href = "/login"
      } 
    }
    return Promise.resolve(res);
  },
  (error) => {
    //TODO:在此处理服务器异常或自定义错误异常
    //console.log('err' + error.response.status);
    return Promise.reject(error);
  }
);


// 封装 get 方法，类型为Get
const get: RequstType = async (url,params = {}) => {
  return await axiosInstance.get(url,{params});
};

// 封装 get 方法，类型为Delete
const doDelete: RequstType = async (url,params = {}) => {
  return await axiosInstance.delete(url,{params});
};

// 封装 get 方法，类型为Get
const post: RequstType = async (url, params) => {
  return await axiosInstance.post(url, params);
};

const postUpload: RequstType = async (url, params) => {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return await axiosInstance.post(url, params,config);
};
const postUploadWithoutCredentials: RequstType = async (url, params) => {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
    withCredentials: false
  };
  return await axiosInstance.post(url, params,config);
};

// const postUploadByQiniuToken: RequstType = async (params) => {
//   const config = {
//     headers: { "Content-Type": "multipart/form-data" }
//   };
//   return await axiosInstance.post(GlobalConsts.QiniuUploadUrl, params,config);
// };


const uploadWithProgress: RequstType = async (url, params,cb:any) => {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: function (progressEvent) { //原生获取上传进度的事件
      if (progressEvent.lengthComputable) {
          //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
          //如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
          cb&&cb(progressEvent);
      }
  },
  };
  return await axiosInstance.post(url, params,config);
};

// 获取视频信息，get 请求 url 为视频的 url，url 类似 https://file.ooowin.com/upbyxuepai/20250506/llg_UR--Zcq9MQQEDtwk9-agv9k5.mp4?avinfo
const getVideoInfo = async (url: string) => {
  // headers 中必须包含 content-type: application/json
  // response 为 application/json
  if(!url) {
    throw new Error('url is empty');
  } 
  if(!url.includes('avinfo')) {
    throw new Error('url is not avinfo');
  }
  const config = {
    headers: { "Content-Type": "application/json" },
    withCredentials: false
  };
  const res = await axios.get(url,config)
  console.log("getVideoInfo res",res)
  //const res: AxiosResponse<any, any>
  if(res.status !== 200) {
    throw new Error('get video info failed'); 
  }
  // 解析res.data
  // 已知返回格式为
  // {
  //   "streams": [
  //     {
  //       "index": 0,
  //       "codec_name": "h264",
  //       "codec_long_name": "H.264 / AVC / MPEG-4 AVC / MPEG-4 part 10",
  //     }    
  //   ]          
  // }
  // 解析视频格式为H264还是h265
  // @ts-ignore
  if(res.data.streams && res.data.streams.length > 0) {
    // @ts-ignore
    const codec_name = res.data.streams[0].codec_name; 
    if(codec_name ===  'h264') {
      return 'h264';
    } else if(codec_name === 'hevc') {
      return 'h265';
    } else {
      throw new Error('video codec is not h264 or h265');
    }
  }
  // 上述返回的promise，如何直接返回类型，不返回promise
  // 可以使用 async/await 或者 then/catch
  // 也可以使用 Promise.resolve() 或者 Promise.reject()
  // 也可以使用 try/catch
  // 也可以使用 Promise.all()     
  // 也可以使用 Promise.race()  

  // 将 Promise<"h264" | "h265" | undefined> ，转为 字符串返回
  // 可以使用 Promise.resolve() 或者 Promise.reject()
  
}

const HttpUtils = {
  get,
  doDelete,
  post,
  postUpload,
  uploadWithProgress,
  postUploadWithoutCredentials,
  getVideoInfo
  // postUploadByQiniuToken
};

// 导出封装后的axios
export default HttpUtils;
